import Text from '../../../../../../components/shared/Typography/Text';
import RichText from '../../../../../LandingV2/Page/RightSide/blocks/Text';

function Textbox() {
  return (
    <Text size="medium">
      <RichText />
    </Text>
  );
}

export default Textbox;
